import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { EventType, InteractionStatus } from "@azure/msal-browser";

const WARNING_LEVEL = 60;

export const useSessionTracking = () => {
  const { instance, inProgress } = useMsal();
  const [showWarning, setShowWarning] = useState(false);
  const [seconds, setSeconds] = useState(300);
  const [expiry, setExpiry] = useState<Date | undefined>();

  const logout = async () => {
    if (instance && inProgress === InteractionStatus.None)
      await instance.logoutRedirect().catch((error) => console.log(error));
  };

  useEffect(() => {
    // Listen to msal events to determine token expiration
    const callbackId = instance.addEventCallback(async (message) => {
      if (message.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
        const result: any = message.payload;
        if (result?.idTokenClaims?.exp) {
          var date = new Date(0);
          date.setUTCSeconds(result.idTokenClaims.exp);
          setExpiry(date);
        }
      } else if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        // Temporary logging statment for information gathering
        console.log(JSON.stringify(message));
        
        await logout();
      }
      else if (message.eventType !== EventType.ACQUIRE_TOKEN_START) {
        // Temporary logging statment for information gathering
        console.log(JSON.stringify(message));
      }
    });

    return () => {
      if (callbackId) instance.removeEventCallback(callbackId);
    };
  }, []);

  useEffect(() => {
    if (!expiry) return;

    const intv = window.setInterval(async () => {
      const now = new Date();
      const diff = (expiry.getTime() - now.getTime()) / 1000.0;

      if (diff < 0) await logout();
      else {
        setShowWarning(diff < WARNING_LEVEL);
        setSeconds(diff);
      }
    }, 1000);

    return () => {
      window.clearInterval(intv);
    };
  }, [expiry, instance]);

  return {
    showWarning,
    seconds,
  };
};
